module.exports = __webpack_public_path__ + "static/media/TV.9a28e89b.svg";